module.exports = __webpack_public_path__ + "static/media/UP.1b463abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keyboard/UP.png
// module id = 183
// module chunks = 0